import { usePage } from '@inertiajs/react';

type FlashProps = {
  flash?: {
    notice?: string | null;
    alert?: string | null;
  };
};

type FlashMessage = {
  key: 'notice' | 'alert';
  message: string;
  icon: string;
  className: string;
};

export function FlashMessages() {
  const { flash } = usePage<FlashProps>().props;

  const messages: FlashMessage[] = [];
  if (flash?.notice) {
    messages.push({
      key: 'notice',
      message: flash.notice,
      icon: 'check_circle',
      className:
        'border-tertiary/30 bg-tertiary/[0.08] text-on-surface [&_.flash-icon]:text-tertiary',
    });
  }
  if (flash?.alert) {
    messages.push({
      key: 'alert',
      message: flash.alert,
      icon: 'error',
      className: 'border-error/30 bg-error/[0.08] text-on-surface [&_.flash-icon]:text-error',
    });
  }

  if (messages.length === 0) return null;

  return (
    <div className="mb-5 grid gap-2" aria-live="polite">
      {messages.map((item) => (
        <div
          key={item.key}
          role={item.key === 'alert' ? 'alert' : 'status'}
          className={`flex items-center gap-3 rounded-lg border px-3 py-2 text-sm ${item.className}`}
        >
          <span className="material-symbols-outlined flash-icon shrink-0 text-[18px]">
            {item.icon}
          </span>
          <span className="font-medium">{item.message}</span>
        </div>
      ))}
    </div>
  );
}
